module.exports = __webpack_public_path__ + "static/00010.63a38959.jpg";